import { render, staticRenderFns } from "./PermissionCellToggle.vue?vue&type=template&id=8f0433b0&"
import script from "./PermissionCellToggle.vue?vue&type=script&lang=js&"
export * from "./PermissionCellToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports